export const Config = {
    environment: null,
    baseUrl: {
        configuration: "",
        ui: ""
    },

    user: null,
    seller: null,
    display: null
};


// WEBPACK FOOTER //
// ./src/js/application/Config.js